export type ErrorProps = {
  statusCode: number
  header: string
  subheader: string
  buttonText: string
}

export const defaultErrorProps: Record<string, Omit<ErrorProps, 'statusCode'>> = {
  'es-ES': {
    header: '¡Ups! Algo ha ido mal',
    subheader: 'La página que buscas no se ha podido cargar.',
    buttonText: 'Continúa en la página inicial',
  },
  'ca-ES': {
    header: 'Ups! Alguna cosa ha anat malament',
    subheader: "La pàgina que busques no s'ha pogut carregar.",
    buttonText: 'Continua a la pàgina inicial',
  },
}
